module.exports = "<div class=\"utilizationBar\">\n  <div\n    class=\"status {{ $ctrl.status }}\"\n    ng-class=\"{ 'complete': $ctrl.isComplete }\"\n    style=\"width: {{$ctrl.percentage}}%\"\n  >\n    utilization bar\n  </div>\n  <md-tooltip md-direction=\"top\">{{$ctrl.roundedPercentage}}%</md-tooltip>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/utilizationBar/utilizationBar.html
// module id = 985
// module chunks = 0